export const INLINE_STYLES = [
    {label: 'B', style: 'BOLD'},
    {label: 'I', style: 'ITALIC'},
    {label: 'U', style: 'UNDERLINE'},
    {label: 'S', style: 'STRIKETHROUGH'}
]

/*
 * Custom overrides for "code" style
 * */
export const styleMap = {
    CODE: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
        fontSize: 16,
        padding: 2,
    },
}

export const MAX_SIZE_BYTES = 2000000

export const ACCEPTED_IMG_FORMATS = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
]

const clearDeltaHtml = (node, delta) => {
    delta.ops = delta.ops.map(op => ({insert:op.insert}))
    return delta
}

export const modules = {
    toolbar : {
        container : [
            [{ 'header': [1, 2, 3, 4, false] }, { color: [] }],
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            ['clean'],
        ],
    },
    clipboard: {
        matchers : [
            ["mark", clearDeltaHtml],
        ]
    }
}

export const getYouTubeSrcFromId = (id) => `https://www.youtube.com/embed/${id}?showinfo=0`

export const configToolbar = () => {

}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/EditorMedia/utils.js